import React, { useState, useEffect, useCallback } from 'react';
import './home.scss';
import { useSignalR } from '../../hooks/useSignalR';
import { getHubUrl } from '../../config/signalr-config';
import { Button } from 'devextreme-react/button';
import { TextBox } from 'devextreme-react/text-box';
import { List } from 'devextreme-react/list';
import { SelectBox } from 'devextreme-react/select-box';
import { PublicCompetitionScoreboard } from '../../components';

export default function Home() {


  return (
    <React.Fragment>
      <div className="home-container">
       <PublicCompetitionScoreboard competitionName={"Stolle2025"} />
      
      </div>
    </React.Fragment>
  );
}
